import { PropTypes } from 'typed/imports';
import { ComponentEventHandler1, PureComponent } from 'typed/components/utils';
import { PeriodType } from 'typed/api';
import { PeriodSelect } from 'typed/components/common';
import { TextInput } from 'components/common';
import { Period } from 'typed/utils';
import './DateTimeInput.less';

const
    TIME_DIGITS_COUNT = 4,
    MINUTES_IN_HOUR = 60,
    HOURS_IN_DAY = 24;

interface Props {
    value?: Date;
    disabled?: boolean;
    onChange?: ComponentEventHandler1<Date>;
}

interface State {}

export default class DateTimeInput extends PureComponent<Props, State> {
    static readonly propTypes = {
        value: PropTypes.instanceOf(Date),
        onChange: PropTypes.func
    };

    static readonly defaultProps = {
        disabled: false
    };


    componentWillMount() {
        this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(nextProps: Props) {
        if (!nextProps.value) { this._onChange(this, new Date()); }
    }


    private _onChange: ComponentEventHandler1<Date> = (_sender, value) => {
        if (this.props.onChange) { this.props.onChange(this, value); }
    };

    private _onPeriodChange: ComponentEventHandler1<Period | null> = (_sender, value) => {
        const currentDate = this.props.value!;
        this._onChange(this, new Date(Date.UTC(value!.getUTCFullYear(), value!.getUTCMonth(), value!.getUTCDate(), currentDate.getUTCHours(), currentDate.getUTCMinutes())));
    };

    private _onDateTimeBlur: ComponentEventHandler1<string> = (_sender, value) => {
        const dateNumbers = value.replace(/\D+/g, '').slice(0, TIME_DIGITS_COUNT);
        if (dateNumbers.length !== TIME_DIGITS_COUNT) { return; }

        const
            currentDate = this.props.value!,

            hours = parseInt(dateNumbers.slice(0, 2)),
            minutes = parseInt(dateNumbers.slice(2)),

            validHours = Math.max(0, Math.min(hours, HOURS_IN_DAY)),
            validMinutes = Math.max(0, Math.min(minutes, MINUTES_IN_HOUR)),

            date = new Date(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate(), validHours, validMinutes);

        this._onChange(this, new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes())));
    };

    private _getTimeString() {
        const { value } = this.props;
        if (!value) { return '00:00'; }

        const
            hours = value!.getHours(),
            minutes = value!.getMinutes();

        return `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}`;
    }

    render() {
        return (
            <div className="date-time-input">
                <PeriodSelect
                    periodTypes={[PeriodType.DAY]}
                    clearable={false}
                    value={new Period(PeriodType.DAY, this.props.value)}
                    disabled={this.props.disabled}
                    onChange={this._onPeriodChange}
                />
                <TextInput clearable={false} value={this._getTimeString()} disabled={this.props.disabled} onBlur={this._onDateTimeBlur} />
            </div>
        );
    }
}
